import React, { Fragment, useState, useEffect } from "react";
import { Button, Form, FormGroup, Label, Input, Col, Row,} from "reactstrap";
import { TimePicker } from "react-time-picker";
import Select from "react-select";
import MenuItem from "react-select";
import { render } from "@testing-library/react";
import "../../../style/calendarclass.css";
import moment from "moment";
import api from "../../../apis/api";
import { faL } from "@fortawesome/free-solid-svg-icons";
import Notifications from "../../../components/common/Notifications";
import LoadingOverlay from "react-loading-overlay";
import styled, { css } from "styled-components";
const FormFieldLeaveTypeAll = React.memo((props) => {
  const { inputFields, formValidation ,intimeval,outtimeval,halfdayworkval,fulldayworkval,employeeType,requestTypeList,selectedItem} = props;
  const [inputFieldsArr, setInputFieldsArr] = useState(null);
const[desoptions , setOptions] =useState([{}]);
let options=[];
const [radioButtonType, setRadioButtonType] = useState("");
const[dutyTypeId,setdutytypeId]=useState([]);
const[dutyType,setdutytype]=useState([]);
const[requestTypeId,setrequesttypeId]=useState([]);
const[requestType,setrequesttype]=useState([]);
const[employeeTypeId,setEmployeeTypeId]=useState(0);
const [Isminimumworkingdays, setIsminimumworkingdays] = useState(false);
const [minimumworkingdays, setminimumworkingdays] = useState(0);
const [IsFirstOccurance, setIsFirstOccurance] = useState(false);
const [FirstOccurance, setFirstOccurance] = useState(0);
const [timesinFirstOccurance, setTimesInFirstOccurance] = useState(0);
const [AfterFirstOccurance, setAfterFirstOccurance] = useState(0);
const [Isnooftimes, setIsnooftimes] = useState(false);
const [nooftimes, setnooftimes] = useState(0);
const [leavetype, setleavetype] = useState("");
const [leavePerYear, setLeavePerYear] = useState(0);
const [leaveCarryForwarded, setLeaveCarryForwarded] = useState(0);
const [leaveAppyPerYear, setLeaveAppyPerYear] = useState(0);
const [numberofleave,setnumberofleave] =useState(0);
const [numberofleaveperwork,setnumberofleavePerwork] =useState("");
const [IsServingNotice,setIsservingNoticeperiod] =useState(false);
const [IsmaximumAccumulation,setIsmaximumAccumulation] =useState(false);
const [IsminimumMaintained,setIsminimumMaintained] =useState(false);
const [maximumAccumulation,setmaximumAccumulation] =useState(0);
const [minimumMaintained,setminimumMaintained] =useState(0);
const [IsnofdaysperYear,setIsnofdaysperYear]=useState(false);
const [Isnofdaysperorganization,setIsnofdaysperorganization]=useState(false);
const [Isnofdaysperhalfyear,setIsnofdaysperhalfyear]=useState(false);
const [noofdaysperyear,setnoofdaysperyear] =useState(0);
const [noofdaysperOrganiz,setnoofdaysperOrganiz] =useState(0);
const [noofdaysperhalfyear,setnoofdaysperhalfyear] =useState(0);
const [noofdutyperyear,setnoofdutyperyear] =useState(0);
const [appliednoofduty,setappliednoofduty] =useState(0);
const [dutygender,setdutygender] = useState("");
const [leavegender,setleavegender] = useState("");
const [error, setError] = useState(null);
const [loaded, setLoaded] = useState(false);
   
const DarkBackground = styled.div`
display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 999; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
${(props) =>
  props.disappear &&
  css`
    display: block; /* show */
  `}
`;
let optionselect=[];
let optionselectemp=[];
if(requestTypeList.length >0)
    {
      // optionsprop.push({value:0,label:"Select..."})
      requestTypeList.map((el,i) =>{
        optionselect.push({value :el.requestTypeId ,label:el.requestType})
      
      })

    }
    if(employeeType.length >0)
    {
      employeeType.map((el,i) =>{
        optionselectemp.push({value :el.employeeTypeId ,label:el.employeeTypeValue})
      
      })
    }
// const [IsLeavesPerYear,setIsLeavesPerYear] =useState("");
// const [IsLeavesPerOrganization,setIsLeavesPerOrganization] =useState("");


  //  inputFields.map(function (desig) {
  //   if(desig.type=="multipleselect" && desig.option.length >0)
  //   {
  //     desig.option.map((el,i) =>{
  //      options.push({value: el.designationId, label: el.designationName }); 
  //     })
     
  //   }
       
  // })

  let intim=moment(intimeval, "hhmma").format("HH:mm");
  let outtim=moment(outtimeval, "hhmma").format("HH:mm");
  const onchangerequesttype= React.useCallback((e,val) =>{
    setrequesttype(val);
  });
  const onchangeisminimumdays= React.useCallback((e) =>{
    setIsminimumworkingdays(!Isminimumworkingdays);
    if(Isminimumworkingdays == true)
    {
      setminimumworkingdays("");
    }
  },[Isminimumworkingdays]);
  const onchangeisfirstoccurance= React.useCallback((e) =>{
    setIsFirstOccurance(!IsFirstOccurance);
    if(IsFirstOccurance == true)
    {
      setFirstOccurance("");
    }
  },[IsFirstOccurance]);
  const onchangeservingnoticeperiod =React.useCallback((e) =>{
   setIsservingNoticeperiod(!IsServingNotice);
  },[IsServingNotice]);
  const onchangemaximumaccumulation =React.useCallback((e) => {
   setIsmaximumAccumulation(!IsmaximumAccumulation);
  },[IsmaximumAccumulation]);
  const onchangeminimummaintainbalance =React.useCallback((e) => {
    setIsminimumMaintained(!IsminimumMaintained);
  },[IsminimumMaintained])
  const onchangeisnooftimes= React.useCallback((e) =>{
    setIsnooftimes(!Isnooftimes);
    if(Isnooftimes == true)
    {
      setnooftimes("");
    }
  },[Isnooftimes]);
  const toggleradiobutton =React.useCallback((e) => {
    if(e==1)
    {
     setIsnofdaysperYear(true);
     setIsnofdaysperorganization(false);
     setIsnofdaysperhalfyear(false);
    }
    else if(e==2)
    {
      setIsnofdaysperYear(false);
      setIsnofdaysperorganization(true);
      setIsnofdaysperhalfyear(false);
    }
    else
    {
      setIsnofdaysperYear(false);
      setIsnofdaysperorganization(false);
      setIsnofdaysperhalfyear(true);
    }
  });
const toggleleaveradiobutton =React.useCallback((e) => {
  if(e==1)
  {
    setleavegender("Female");
  }
  else
  {
    setleavegender("Male");
  }
});
  const toggledutyradiobutton =React.useCallback((e) => {
    if(e==1)
    {
     setdutygender("Female");
    }
    else
    {
      setdutygender("Male");
    
    }
  });
  const submitLeave= (e) =>{
    e.preventDefault();
    setLoaded(true);
    let formData = {};
    formData = {
      LeaveTypeId: 0,
      Type: selectedItem.leaveType,
      NoOfLeavesPerYear: parseInt(noofdaysperyear),
      NoOfLeavesCarryForwarded: parseInt(leaveCarryForwarded),
      NoOfLeavesAppliedPerYear: parseInt(leaveAppyPerYear),
      // DaysToServeFromDOJ: parseInt(selectedSubCatgory.ticketId),
      // DaysToServeInYear: parseInt(selectedSubCatgory.ticketId),
      Gender: leavegender,
      TotalAccumulation: parseInt(0),
      IsLeavesPerYear: IsnofdaysperYear,
      IsLeavesPerOrganization: Isnofdaysperorganization,
      LeavesPerOrganization: parseInt(noofdaysperOrganiz),
      IsLeavesPerHalfYear:Isnofdaysperhalfyear,
      LeavesPerHalfYear :parseInt(noofdaysperhalfyear),
      IsMinimumWorkingDays: Isminimumworkingdays,
      MinimumWorkingDays: parseInt(minimumworkingdays),
      IsNumberOfTime: Isnooftimes,
      NumberOfTimes: parseInt(nooftimes),
      IsServingNoticePeriodCondition: IsServingNotice,
      NoticePeriodPerDay: parseInt(numberofleave),
      IsMaximumAccumulation: IsmaximumAccumulation,
      MaximumAccumulation: parseInt(maximumAccumulation),
      IsMinimumMaintainedBal: IsminimumMaintained,
      MinimumMaintainedBalance: parseInt(minimumMaintained),
      EmployeeTypeId:parseInt(employeeTypeId),
      IsFirstOccurance :IsFirstOccurance,
      TimesinFirstOccurance :parseInt(timesinFirstOccurance),
      FirstOccurance :parseInt(FirstOccurance),
      AfterFirstOccurance :parseInt(AfterFirstOccurance),
      LeaveTypeMasterId:parseInt(selectedItem.id),
    }
    api.dbLeaveTypes().AddEditLeaveTypes(formData);
    setError({ ...error, message: "Leave Added..", status: 200 });
    setTimeout(() => { 
      window.location.reload();
      setLoaded(false);
  }, 3000);

  };
  const callBackAfterValidation =async () => {
    // console.log("formValidation:", selectedLeaves.id);
    setLoaded(true);
   
          let formData = {
            DutyTypeId:0,
            Type: selectedItem.leaveType,
            Status:"true",
            NoOfDaysPerYear: parseFloat(noofdutyperyear) ,
            CarryForwarded:0,
              AppliedPerYear:parseFloat(appliednoofduty) ,
              DaysToServeFromDOJ:0,
              DaysToServeInYear:0,
              Gender :dutygender,
              TotalAccumulation:0,
              IsActive:"true",
              TypeID:parseInt(selectedItem.id),
          };
          // addDuty(formData);
          await api.dbLeaveTypes().AddEditDutyTypes(formData);
        
          setError({ ...error, message: "Duty Added..", status: 200 });
      
        // toggle();
      
        setTimeout(() => { 
          window.location.reload();
          setLoaded(false);
      }, 2000);
    
  
};
  return (
    <Form>
        <Row form>
        {/* <Col md={6}>
          <FormGroup>
          <Label for="exampleEmail">Request Type</Label>
          
                    <Select
        className="basic-single"
        classNamePrefix="select"
        defaultValue={optionselect[0]}
        onChange={(e) => {
          onchangerequesttype(e.value,e.label);
        }} 
        isSearchable={true}
        name="color"
        options={optionselect}
      />
          </FormGroup>
          </Col>
          */}
          </Row>
      {props.reqType=="Leave" ? (<div><Row form>
          <Col md={6}>
          <FormGroup>
          <Label for="exampleEmail">Employee Type</Label>
        
                    <Select
        className="basic-single"
        classNamePrefix="select"
        defaultValue={optionselectemp[0]}
        onChange={(e) => {
          setEmployeeTypeId(e.value);
        }} 
        isSearchable={true}
        name="color"
        options={optionselectemp}
      />
          </FormGroup>
          </Col>
        <Col md={6}>
          <FormGroup>
          <Label for="exampleEmail">Leave Type</Label>
          <Input
              type="text"
               value={selectedItem.leaveType}
               onChange={(e) => setleavetype(e.target.value)}
               placeholder="Leave Type"
               disabled={true}
            />
          </FormGroup>
          </Col>
          
          </Row>
          <Row form>
        <Col md={6}>
          <FormGroup>
          <Label for="exampleEmail">No of Leaves Carry Forwarded</Label>
          <Input
              type="text"
              value={leaveCarryForwarded}
              placeholder="No of Leaves Carry Forwarded"
              onChange={(e) => setLeaveCarryForwarded(e.target.value)}
            />
          </FormGroup>
          </Col>
          <Col md={6}>
          <FormGroup>
          <Label for="exampleEmail">No of Leave Applied Per Year</Label>
          <Input
              type="number"
              value={leaveAppyPerYear}
              placeholder="No of Leave Applied Per Year"
              onChange={(e) => setLeaveAppyPerYear(e.target.value)}
            />
          </FormGroup>
          </Col>
          </Row>
          <Row form>
          <Col md={8}>
          <FormGroup className="singlerow smallfont" check>
            <Label check className="radio-days">
              <Input type="radio" name="radio2" onClick={() =>toggleradiobutton(1)}/>Leaves Per Year </Label>
              <Label check className="radio-days">  
              <Input type="radio" name="radio2" onClick={() =>toggleradiobutton(2)} />Leaves During Service</Label>
              <Label check className="radio-days">  
              <Input type="radio" name="radio2" onClick={() =>toggleradiobutton(3)} />Leaves Per HalfYear</Label>
            </FormGroup>
          </Col>
       {IsnofdaysperYear == true ?(<Col md={4}>
          <FormGroup>
          <Label for="exampleEmail">No of Leaves Per Year</Label>
          <Input
              type="number"
              value={noofdaysperyear}
              placeholder="No of Leaves Per Year"
              onChange={(e) => setnoofdaysperyear(e.target.value)}
            />
          </FormGroup>
          </Col>) : (Isnofdaysperorganization ==true ? (<Col md={6}>
          <FormGroup>
          <Label for="exampleEmail">No of Leaves Per Organization</Label>
          <Input
              type="number"
              value={noofdaysperOrganiz}
              placeholder="No of Leaves Per Year"
              onChange={(e) => setnoofdaysperOrganiz(e.target.value)}
            />
          </FormGroup>
          </Col>) : (Isnofdaysperhalfyear == true ?(<Col md={3}>
          <FormGroup>
          <Label for="exampleEmail">No of Leaves Per HalfYear</Label>
          <Input
              type="number"
              value={noofdaysperhalfyear}
              placeholder="No of Leaves Per HalfYear"
              onChange={(e) => setnoofdaysperhalfyear(e.target.value)}
            />
          </FormGroup>
          </Col>) : null) )}   
          </Row>
          <br/>
           <Row form>
                  <Col md={3}>
                    <FormGroup className="singlerow">
                    <Label for="exampleEmail">No of times in first occurance</Label>
                    <Input
                        type="checkbox"
                        className="singleradio"
                        value={IsFirstOccurance}
                        onChange={(e) => onchangeisfirstoccurance(e.target.value)}
                        checked={IsFirstOccurance == true?true : false}
                      />
                    </FormGroup>
                    </Col>
                    {IsFirstOccurance == true ? (<Col md={3}>
                      <FormGroup>
                        <Label>No of times in first occurance</Label>
                        <Input type="text"
                         value={timesinFirstOccurance}
                         placeholder="Times in first occurance"
                         onChange={(e) => setTimesInFirstOccurance(e.target.value)}
                        ></Input>
                      </FormGroup>
                    </Col>) : null} 
                  {IsFirstOccurance == true ? (<Col md={3}>
                      <FormGroup>
                        <Label>No of leaves in first occurance</Label>
                        <Input type="text"
                         value={FirstOccurance}
                         placeholder="Leaves in first occurance"
                         onChange={(e) => setFirstOccurance(e.target.value)}
                        ></Input>
                      </FormGroup>
                    </Col>) : null}  
                    {IsFirstOccurance == true ? (<Col md={3}>
                      <FormGroup>
                        <Label>No of leaves after first occurance</Label>
                        <Input type="text"
                         value={AfterFirstOccurance}
                         placeholder="After First Occurance"
                         onChange={(e) => setAfterFirstOccurance(e.target.value)}
                        ></Input>
                      </FormGroup>
                    </Col>) : null}
                    </Row>
          <Row form>
        <Col md={6}>
          <FormGroup className="singlerow">
          <Label for="exampleEmail">Minimum Working Days</Label>
          <Input
              type="checkbox"
              className="singleradio"
              value={Isminimumworkingdays}
              onChange={(e) => onchangeisminimumdays(e.target.value)}
            />
          </FormGroup>
          </Col>
        {Isminimumworkingdays == true ? (<Col md={6}>
            <FormGroup>
              <Label>Minimum Working Days</Label>
              <Input type="text"
               value={minimumworkingdays}
               placeholder="Minimum Working Days"
               onChange={(e) => setminimumworkingdays(e.target.value)}
              ></Input>
            </FormGroup>
          </Col>) : null}  
          </Row>
          <Row>
          <Col md={6}>
          <FormGroup className="singlerow">
          <Label for="exampleEmail">No of Times</Label>
          <Input
              type="checkbox"
              className="singleradio"
              value={Isnooftimes}
              onChange={(e) => onchangeisnooftimes(e.target.value)}
            />
          </FormGroup>
          </Col>
        {Isnooftimes == true ? (<Col md={6}>
            <FormGroup>
              <Label>No of Times</Label>
              <Input type="text"
              value={nooftimes}
              onChange={(e) => setnooftimes(e.target.value)}
              placeholder="No of Times"
              ></Input>
            </FormGroup>
          </Col>) : null}  
          </Row>
          <Row>
            <Col md={6}>
            <FormGroup className="singlerow">
              <Label>Serving Notice Period</Label>
              <Input type="checkbox"
              className="singleradio"
              value={IsServingNotice}
              onChange={(e) => onchangeservingnoticeperiod(e.target.value)}></Input>
            </FormGroup>
            </Col>
           {IsServingNotice == true ? (<Col md={6}>
              <FormGroup>
                <Row>
                <Col md={6}>
                <Label>Number Of Leaves</Label>
                <Input type="text" value={numberofleave} onChange={(e) => setnumberofleave(e.target.value)}></Input>
                </Col>
                <Col md={6}>
                <Label>Per Working Days</Label>
                <Input type="text" value={numberofleaveperwork} onChange={(e) =>setnumberofleavePerwork(e.target.value)}></Input>
                </Col>
                </Row>
               
              </FormGroup>
            </Col>) : null} 
          </Row>
          <Row>
            <Col md={6}>
            <FormGroup className="singlerow">
              <Label>Maximum Accumulation</Label>
              <Input type="checkbox"
              className="singleradio"
              value={IsmaximumAccumulation}
              onChange={(e) => onchangemaximumaccumulation(e.target.value)}></Input>
            </FormGroup>
            </Col>
           {IsmaximumAccumulation == true ? (<Col md={6}>
              <FormGroup>

                <Label>Number Of Maximum Accumulation</Label>
                <Input type="text" value={maximumAccumulation} onChange={(e) => setmaximumAccumulation(e.target.value)}></Input>
               
               
              </FormGroup>
            </Col>) : null} 
          </Row>
          <Row>
            <Col md={6}>
            <FormGroup className="singlerow">
              <Label>Minimum Maintained Balance</Label>
              <Input type="checkbox"
              className="singleradio"
              value={IsminimumMaintained}
              onChange={(e) => onchangeminimummaintainbalance(e.target.value)}></Input>
            </FormGroup>
            </Col>
           {IsminimumMaintained == true ? (<Col md={6}>
              <FormGroup>

                <Label>Minimum Maintained Balance</Label>
                <Input type="text" value={minimumMaintained} onChange={(e) => setminimumMaintained(e.target.value)}></Input>
               
               
              </FormGroup>
            </Col>) : null} 
          </Row>
          <Row>
            <Col md={6}>
            <FormGroup check>
            <Label check className="radio-days">
              <Input type="radio" name="radio1"  onClick={() =>toggleleaveradiobutton(1)}/>Female </Label>
              <Label check className="radio-days">  
              <Input type="radio" name="radio1"  onClick={() =>toggleleaveradiobutton(2)}/>Male</Label>
            </FormGroup>
            </Col>
          </Row></div>) : 
          (props.reqType=="Duty" ? (<div>
            <Row form>
          
        <Col md={6}>
          <FormGroup>
          <Label for="exampleEmail">Duty Type</Label>
          <Input
              type="text"
               value={selectedItem.leaveType}
               onChange={(e) => setdutytype(e.target.value)}
               placeholder="Duty Type"
               disabled={true}
            />
          </FormGroup>
          </Col>
          
          </Row>
          <Row form>
          <Col md={6}>
          <FormGroup>
          <Label for="exampleEmail">No of Duty Per Year</Label>
          <Input
              type="number"
              value={noofdutyperyear}
              placeholder="No of Duty Per Year"
              onChange={(e) => setnoofdutyperyear(e.target.value)}
            />
          </FormGroup>
          </Col>
          <Col md={6}>
          <FormGroup>
          <Label for="exampleEmail">No of Duty Applied Per Year</Label>
          <Input
              type="number"
              value={appliednoofduty}
              placeholder="No of Duty Applied Per Year"
              onChange={(e) => setappliednoofduty(e.target.value)}
            />
          </FormGroup>
          </Col>
          </Row>
         
         
          <Row>
            <Col md={6}>
            <FormGroup check>
            <Label check className="radio-days">
              <Input type="radio" name="radio1" onClick={() =>toggledutyradiobutton(1)}/>Female </Label>
              <Label check className="radio-days">  
              <Input type="radio" name="radio1" onClick={() =>toggledutyradiobutton(2)}/>Male</Label>
            </FormGroup>
            </Col>
          </Row>
          </div>) : null)
          }    
          <br/>
    {props.reqType == "Duty" ? ( <div><Button
        color=""
        className="btn-admin-settings"
        onClick={callBackAfterValidation}
      >
       Add
      </Button>{" "}
      &nbsp;
      <Button color="" className="btn-cancel" onClick={props.toggle}>
        Cancel
      </Button></div>) : (props.reqType =="Leave" ? ( <div><Button
        color=""
        className="btn-admin-settings"
        onClick={submitLeave}
      >
       Add
      </Button> {" "}
      &nbsp;
      <Button color="" className="btn-cancel" onClick={props.toggle}>
        Cancel
      </Button></div>) : (null))} 
      <Notifications notifications={error}></Notifications>
      <DarkBackground disappear={loaded}>
    <LoadingOverlay
          active={true}
          spinner={true}
          text="Loading your content..."
        >
        </LoadingOverlay>
    </DarkBackground>
    </Form>
  );
});

export default FormFieldLeaveTypeAll;
